import { axiosGet, axiosPost, axiosPostWithFile } from "./apiClient";
const BASE_URL = process.env.REACT_APP_BASE_URL + '/category';


const getAllCategory = async (limit = 10, page = 0, search = null) => {
    try {
        const response = await axiosGet(`${BASE_URL}/get`, {

            limit,
            page,
            search

        });
        return response;
    } catch (error) {
        console.error('Error fetching all categories:', error);
        throw error;
    }
};

const getCategoryById = async (categoryId) => {
    try {
        const response = await axiosGet(`${BASE_URL}/get/${categoryId}`);
        return response;
    } catch (error) {
        console.error(`Error fetching category ${categoryId}:`, error);
        throw error;
    }
};

const addCategory = async (payload) => {
    try {
        const response = await axiosPostWithFile(`${BASE_URL}/add`, payload);
        return response;
    } catch (error) {
        console.error(`Error adding category:`, error);
        throw error;
    }
};

const updateCategory = async (categoryId) => {
    try {
        const response = await axiosGet(`${BASE_URL}/add/${categoryId}`);
        return response;
    } catch (error) {
        console.error(`Error updating category ${categoryId}:`, error);
        throw error;
    }
};
const categoryAPI = {
    getAllCategory,
    getCategoryById,
    addCategory,
    updateCategory
};

// Export the named object
export default categoryAPI;